import api from "api";
import secureLocalStorage from "react-secure-storage";

export default function getDataForHome() {
  const id = secureLocalStorage.getItem("id");
  return api.get(`/assignment-summary/${id}`);
}

export function assignedOrder(sd,ed){
  return api.get(`medrep_orders/${secureLocalStorage.getItem('id')}?startDate=${sd}&endDate=${ed}`)
}

export function rawEngagement(sd, ed){
  return api.get(`raw_reminders/${secureLocalStorage.getItem('id')}?start=${sd}&end=${ed}`)
}